import { useAtom } from 'jotai'
import React from 'react'
import { useParams } from 'react-router'

import { brandGroupIdAtom } from '~/atoms'
import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

const document = graphql(`
  query UseSurveyQuery_Main($surveyId: ID!) {
    survey(id: $surveyId, questionDisplayFilter: DETAIL_COUNT) {
      id
      title
      brandAccountId
      brandGroups {
        id
        name
        brands {
          id
          name
          number
        }
        mappedAt
      }
      questions {
        question_id
        question_text
        answer_options {
          option
          text
        }
        mt_questions
      }
      customerAttributeGroups {
        id
        name
        customerAttributes {
          id
          name
          filterGroups {
            category
            question {
              questionId
              operation
              answerOptions {
                option
                text
              }
            }
            customerAttribute {
              customerAttributeIds
              operation
            }
            brandSegments {
              brandGroupId
              brandNumber
              segmentNumbers
            }
          }
        }
      }
    }
  }
`)

export const useSurveyQueryFn = () => {
  const { surveyId = '' } = useParams<{ surveyId: string | undefined }>()

  const graphQLRequest = useGraphQLRequest()

  const [brandGroupId, setBrandGroupId] = useAtom(brandGroupIdAtom)

  return React.useCallback(async () => {
    const result = await graphQLRequest({ document, variables: { surveyId } })

    if (
      result.survey?.brandGroups?.every(
        (brandGroup) => brandGroup?.id !== brandGroupId,
      )
    ) {
      setBrandGroupId(result.survey?.brandGroups?.[0]?.id ?? null)
    }

    return result
  }, [brandGroupId, graphQLRequest, setBrandGroupId, surveyId])
}
